import { Check } from "lucide-react";

interface Step {
  id: number;
  name: string;
}

const steps: Step[] = [
  { id: 1, name: "Identify" },
  { id: 2, name: "Blueprint" },
  { id: 3, name: "Review Blueprint" },
  { id: 4, name: "Generate" },
  { id: 5, name: "Review Items" },
  { id: 6, name: "Finalize Test" },
  { id: 7, name: "Share" },
];

interface ProgressIndicatorProps {
  currentStep: number;
}

export function ProgressIndicator({ currentStep }: ProgressIndicatorProps) {
  return (
    <div className="mb-12">
      <div className="flex items-center justify-center mx-auto">
        {steps.map((step, index) => (
          <div key={step.id} className="flex items-center">
            <div className="flex flex-col items-center shrink-0">
              <div
                className={`flex items-center justify-center w-10 h-10 rounded-full border-2 transition-colors ${
                  step.id < currentStep
                    ? "bg-primary border-primary text-primary-foreground"
                    : step.id === currentStep
                    ? "bg-primary border-primary text-primary-foreground"
                    : "bg-background border-border text-muted-foreground"
                }`}
                data-testid={`step-${step.id}`}
              >
                {step.id < currentStep ? (
                  <Check className="w-5 h-5" />
                ) : (
                  <span className="text-sm font-semibold">{step.id}</span>
                )}
              </div>
              <span
                className={`mt-2 text-xs font-medium text-center whitespace-nowrap ${
                  step.id <= currentStep ? "text-foreground" : "text-muted-foreground"
                }`}
              >
                {step.name}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`h-0.5 transition-colors shrink min-w-0 w-4 sm:w-6 md:w-8 lg:w-12 xl:w-16 mx-1 ${
                  step.id < currentStep ? "bg-primary" : "bg-border"
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
